import React, {useRef} from "react";
import {Container, Row} from "react-bootstrap";
import NavigationBar from "../parts/navigation/NavigationBar";
import Menu from "../parts/menu/Menu";
import GoBackButton from "./GoBackButton";
import utils from "../helpers/utils";
import PrintHeader from "./PrintHeader";

const CustomContainer = (props) => {
    const contentRef = useRef(null);

    return (
        <div id="page-wrapper" className={`${utils.isToggled() ? "toggled" : ""}`}>
            <NavigationBar printRef={contentRef} />
            <div className="d-flex flex-column" id="content-wrapper">
                <div ref={contentRef} className={`${props.wrapper}-wrapper ${props.className} `}>
                    <Container fluid className="d-flex flex-column p-0">
                        <PrintHeader/>
                        {props.back && <GoBackButton url={props.back.url} title={props.back.tittle}/>}
                        <div className={`${props.miniNavClassName} align-items-center sticky-header`}>
                            {props.title && (
                                <h4 className="text-dark d-flex float-left align-items-center mt-2">
                                    {props.parent && props.parent}
                                    {props.title}
                                </h4>
                            )}
                            {props.subtitle && (
                                <h6 className="text-dark float-right pt-1">{props.subtitle}</h6>
                            )}
                        </div>
                        <Row className={props.rowClass} id={"content-row"}>
                            {props.enableReady && props.ready && props.children}
                            {!props.enableReady && props.children}
                        </Row>
                        <Row className="footer"></Row>
                    </Container>
                </div>
            </div>
            <Menu/>
        </div>
    );
};

export default CustomContainer;
